import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react-shared/BuilderUI/utils/twMergeWithCNAndPrefix";

const i18nRoot = "builder_ui.form_block";

export const NoFormSelected = () => (
  <div className={classNames("wb-text-center wb-text-muted")}>
    <div className={classNames("wb-text-lg wb-font-medium")}>
      {t([i18nRoot, "no_form_selected"])}
    </div>
    <div className={classNames("wb-text-sm")}>
      {t([i18nRoot, "select_form_instruction"])}
    </div>
  </div>
);
